import * as action_types from "./constants";
import { GetClientType } from "./types";

export type myCompanyState = {
  clientListData: {
    loader: boolean;
    data: [] | null;
    count: number;
  };
  clientDetailData: {
      loader: boolean;
      data: GetClientType | null;
    };
};

const initialState: myCompanyState = {
  clientListData: {
    loader: true,
    data: null,
    count: 0,
  },
  clientDetailData: {
    loader: true,
    data: null,
  },
};

type MyCompanyActionType =
  | {
      type: typeof action_types.GET_CLIENTS_LISTING;
      data: { payload: []; loading: boolean; count: number };
    }
    | {
          type: typeof action_types.GET_CLIENTS_DETAIL;
          data: { payload: GetClientType; loading: boolean };
        };

const myCompanyReducer = (
  state = initialState,
  action: MyCompanyActionType
): myCompanyState => {
  const { type, data } = action;
  switch (type) {
    case action_types.GET_CLIENTS_LISTING:
      return {
        ...state,
        clientListData: {
          loader: data?.loading,
          data: data?.payload,
          count: data?.count,
        },
      };

      case action_types.GET_CLIENTS_DETAIL:
            return {
              ...state,
              clientDetailData: { data: data?.payload, loader: data?.loading },
            };

    default:
      return state;
  }
};

export default myCompanyReducer;
